import { jsx as _jsx } from "react/jsx-runtime";
import { Clients } from '@src/components/Admin/Clients';
import { useClientIdParam } from '@src/hooks/useClientIdParam';
import { useLocale } from 'pe-core-frontend';
export const ChildClients = () => {
    const { t } = useLocale();
    const parentId = useClientIdParam();
    if (!parentId) {
        return _jsx("div", { children: t('Parent Client is required') });
    }
    return _jsx(Clients, { pageTitle: t('Child Clients'), parentId: parentId });
};
